<template>
  <v-footer class="site-footer" color="#101827" dark>
    <v-container class="pt-10 pb-8">
      <v-row>
        <v-col cols="12" md="4">
          <!-- Plain img, not v-img: same reason as SiteHeader.vue's logo -
               v-img's loading-placeholder/loaded fade transition is a
               structural hydration mismatch source on prerendered routes. -->
          <img src="/images/logo/logo-white-07.svg" width="120" height="120" alt="migly" class="mb-4"/>
          <p class="footer-text">{{ $t('home.footerTagline') }}</p>
          <div class="footer-trust">
            <div class="footer-trust-badge">
              <v-icon size="16" color="#00BDB3">mdi-shield-check</v-icon>
              <small>{{ $t('home.footerLgpd') }}</small>
            </div>
            <div class="footer-trust-badge">
              <v-icon size="16" color="#00BDB3">mdi-lock-check</v-icon>
              <small>{{ $t('home.footerDataProtected') }}</small>
            </div>
          </div>
        </v-col>
        <v-col cols="6" md="4">
          <div class="footer-heading">{{ $t('home.footerNavigation') }}</div>
          <a href="/#recursos" class="footer-link">{{ $t('home.navHowItWorks') }}</a>
          <a href="/#planos" class="footer-link">{{ $t('plansAndPrices') }}</a>
        </v-col>
        <v-col cols="6" md="4">
          <div class="footer-heading">{{ $t('home.footerContact') }}</div>
          <a href="mailto:contato@exatamente-solucoes.com" class="footer-link">contato@exatamente-solucoes.com</a>
          <a href="/privacy-policy" class="footer-link">{{ $t('privacyPolicy') }}</a>
        </v-col>
      </v-row>
      <v-divider class="my-6 footer-divider"/>
      <div class="footer-bottom">
        <small v-html="$t('home.footerProductOf')"></small>
      </div>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'SiteFooter',
}
</script>

<style scoped>
.site-footer {
  border-top: 1px solid rgba(255,255,255,0.08);
  font-family: 'Montserrat', sans-serif;
}
.footer-text {
  color: #B7BFCC;
  font-size: 0.9rem;
  max-width: 320px;
}
.footer-trust {
  display: flex;
  gap: 1rem;
  margin-top: 0.75rem;
}
.footer-trust-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #B7BFCC;
  font-size: 0.78rem;
}
.footer-heading {
  color: #fff;
  font-weight: 700;
  margin-bottom: 0.75rem;
}
.footer-link {
  display: block;
  width: fit-content;
  position: relative;
  color: #B7BFCC;
  text-decoration: none;
  font-size: 0.9rem;
  margin-bottom: 0.6rem;
  transition: color 0.2s ease;
}
.footer-link::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 100%;
  height: 1px;
  background: currentColor;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s cubic-bezier(0.16,1,0.3,1);
}
.footer-link:hover {
  color: #fff;
}
.footer-link:hover::after {
  transform: scaleX(1);
}
.footer-link-inline {
  color: #fff;
  text-decoration: underline;
  text-decoration-color: rgba(255,255,255,0.35);
  transition: text-decoration-color 0.2s ease;
}
.footer-link-inline:hover {
  text-decoration-color: rgba(255,255,255,0.9);
}
.footer-divider {
  border-color: rgba(255,255,255,0.1) !important;
}
.footer-bottom {
  color: #8892A0;
  text-align: center;
}
</style>
